const types = {
  SET_FLOW_STEPS: 'flow/SET_FLOW_STEPS',
  SET_CURRENT_STEP: 'flow/SET_CURRENT_STEP',
  CLEAR_FLOW: 'flow/CLEAR_FLOW',
}

export const setFlowSteps = steps => ({
  type: types.SET_FLOW_STEPS,
  payload: steps,
})

export const setCurrentStep = step => ({
  type: types.SET_CURRENT_STEP,
  payload: step,
})

export const clearFlow = () => ({
  type: types.CLEAR_FLOW,
})

export const initialState = {
  flowSteps: [],
  currentStep: {},
}

export default (state = initialState, { type, payload = {} } = {}) => {
  switch (type) {
    case types.SET_FLOW_STEPS: {
      return {
        ...state,
        flowSteps: payload,
      }
    }

    case types.SET_CURRENT_STEP: {
      return {
        ...state,
        currentStep: payload,
      }
    }

    case types.CLEAR_FLOW: {
      return initialState
    }

    default:
      return state
  }
}
